import { medicalsApi } from "../api/medicalsApi";
import { PA_QUESTIONNAIRE_CODE } from "../pages/health/encounters/cards/PhysicalAssessment/constants";
import { Reference } from "../types/reference";
import { createEncounterIdentifierParam } from "../utils/DataTransformationUtils";
import { FHIRURL } from "../utils/FHIRURL";

const findPhysicalAssessment = async (
  encounterReference: Reference,
  patientReference: Reference,
) => {
  const questionnaire = await medicalsApi.findQuestionnaireResponse(
    PA_QUESTIONNAIRE_CODE,
    {
      limit: 1,
      ...createEncounterIdentifierParam(encounterReference),
      subject: patientReference?.reference,
      "exclude-status": ["entered-in-error"],
    },
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    console.log("Physical assessment questionnaire not found");
    return;
  }

  return questionnaire[0];
};

const findQuestionnaire = async () => {
  const ENTITY_TYPE = "questionnaire";
  const questionnaire = await medicalsApi.findEntities(
    { code: PA_QUESTIONNAIRE_CODE, status: "active" },
    ENTITY_TYPE,
  );

  if (!Array.isArray(questionnaire) || questionnaire.length !== 1) {
    throw new Error(
      "Physical Examination form questionnaire is either more than or less than 1",
    );
  }

  return questionnaire[0];
};

const createDefault = (
  questionnaire: Record<string, unknown>,
  encounterReference: Reference,
  patientReference: Reference,
  authoredDate?: Date,
  practitionerReference?: Reference,
) => {
  return {
    ...questionnaire,
    questionnaire: new FHIRURL(`Questionnaire/${questionnaire.id}`, {
      version: questionnaire.version,
      code: questionnaire.code[0]?.code,
    }).url,

    status: "in-progress",
    encounter: encounterReference,
    subject: patientReference,
    authored: authoredDate || new Date(),
    author: practitionerReference,
    source: practitionerReference,
  };
};

export const PhysicalAssessmentManager = {
  findPhysicalAssessment,
  findQuestionnaire,
  createDefault,
};
